function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import fetch from 'isomorphic-fetch';
import xss from 'xss';
import qs from 'qs';

import Wrapper from './components/wrapper';
import MessageList from './components/message-list';
import TextBox from './components/text-box';

var main = 'hypeChat.jsp';
var poll = 'poll.jsp';
var send = 'remote.jsp';

var ChatOperator = function (_Component) {
  _inherits(ChatOperator, _Component);

  function ChatOperator(props) {
    _classCallCheck(this, ChatOperator);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      sentMessages: [],
      checkMessageHandle: null,
      checkMessageRate: 5000,
      loadingFirstMessage: false,
      shouldSendLogout: true
    };

    _this.addMessage = _this.props.addMessage;
    _this.handleQuestion = _this.handleQuestion.bind(_this);
    _this.checkMessage = _this.checkMessage.bind(_this);
    _this.sendMessage = _this.sendMessage.bind(_this);
    _this.handleError = _this.handleError.bind(_this);

    _this.myxss = new xss.FilterXSS({
      whiteList: {
        a: ['href']
      }
    });
    return _this;
  }

  ChatOperator.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        chatURL = _props.chatURL,
        name = _props.name,
        surname = _props.surname,
        email = _props.email;


    var url = '' + chatURL + main + '?' + qs.stringify({
      nome: name,
      cognome: surname,
      email: email,
      categoria: 'HYPE'
    });

    this.setState({
      loading: true
    });

    return fetch(url, { credentials: 'include' }).then(function (response) {
      return response.text();
    }).then(function (content) {
      var messages = _this2.getHistory(content);

      messages.forEach(function (_ref) {
        var text = _ref.text,
            sender = _ref.sender,
            senderName = _ref.senderName;
        return _this2.addMessage({
          text: text,
          user: sender.toUpperCase(),
          name: senderName
        });
      });

      _this2.setState({ sentMessages: messages });

      var checkMessageHandle = setInterval(_this2.checkMessage, _this2.state.checkMessageRate);
      _this2.setState({
        checkMessageHandle: checkMessageHandle,
        loadingFirstMessage: true
      });
    }).catch(this.handleError);
  };

  ChatOperator.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.state.checkMessageHandle);
    this.sendLogout();
  };

  ChatOperator.prototype.handleQuestion = function handleQuestion(e) {
    if (e.key === 'Enter') {
      if (e.target.value === '') {
        return;
      }

      var question = this.myxss.process(e.target.value);
      this.addMessage({ text: question, user: 'CUSTOMER' });
      this.sendMessage(question);

      e.target.value = '';
    }
  };

  ChatOperator.prototype.checkMessage = function checkMessage() {
    var _this3 = this;

    return fetch('' + this.props.chatURL + poll + '?' + qs.stringify({ _dc: Date.now() }), { credentials: 'include' }).then(function (response) {
      return response.text();
    }).then(function (content) {
      try {
        content = JSON.parse(content);
      } catch (e) {
        content = null;
      }

      if (content) {
        if (content.isFinished) {
          _this3.addMessage({
            text: 'Chat terminata'
          });
          _this3.setState({
            loading: false,
            shouldSendLogout: false
          });
          _this3.props.switchToSurvey();
        } else {
          var messages = _this3.getMessages(content.data);

          if (messages.length > 0) {
            messages.forEach(function (_ref2) {
              var text = _ref2.text,
                  sender = _ref2.sender,
                  senderName = _ref2.senderName;

              _this3.addMessage({
                text: text,
                user: sender.toUpperCase(),
                name: senderName
              });
            });

            if (_this3.state.loadingFirstMessage) {
              _this3.setState({
                loadingFirstMessage: false,
                loading: false
              });
            }
          }
        }
      }
    }).catch(this.handleError);
  };

  ChatOperator.prototype.parseMessage = function parseMessage(m) {
    var msg = {
      sender: m.replace(/.*data\-sender=\"([^"]*)\".*/, '$1').replace('Gruppo Banca Sella', 'bot'),
      text: m.replace(/\<div[^>]*>\<span[^>]*\>\<\/span\>\<p[^>]*\>([^<]*)\<\/p\>\<\/div\>/, '$1')
    };

    if (msg.sender !== 'bot' && msg.sender.toLowerCase() !== (this.props.name + ' ' + this.props.surname.substr(0, 1)).toLowerCase()) {
      msg.senderName = msg.sender;
      msg.sender = 'operator';
    } else if (msg.sender !== 'bot' && msg.sender.toLowerCase() === (this.props.name + ' ' + this.props.surname.substr(0, 1)).toLowerCase()) {
      msg = null;
    } else if (msg.sender === 'bot') {
      msg.senderName = this.props.chatbotName;
    }
    return msg;
  };

  ChatOperator.prototype.getHistory = function getHistory(text) {
    var _this4 = this;

    return (text.match(/<div class="chat-message[^"]*"><span class="chat-message__sender" data-sender="[^\"]*"><\/span><p class="chat-message__text">[^>]*<\/p><\/div>/g) || []).map(function (m) {
      return _this4.parseMessage(m);
    }).filter(function (m) {
      return !!m;
    });
  };

  ChatOperator.prototype.getMessages = function getMessages(data) {
    var _this5 = this;

    return data.match(/\<div[^>]*>\<span[^>]*\>\<\/span\>\<p[^>]*\>([^<]*)\<\/p\>\<\/div\>/g).map(function (m) {
      return _this5.parseMessage(m);
    }).filter(function (m) {
      return !!m;
    });
  };

  ChatOperator.prototype.sendMessage = function sendMessage(message) {
    var _this6 = this;

    var messageData = {
      action: 'ChatServer',
      method: 'submitNewComment',
      data: [message],
      type: 'rpc',
      tid: this.state.sentMessages.length + 1
    };

    this.setState(function (prevState) {
      return {
        loading: true,
        sentMessages: prevState.sentMessages.concat([messageData])
      };
    });

    fetch('' + this.props.chatURL + send, {
      method: 'POST',
      body: JSON.stringify(messageData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function () {
      _this6.setState({
        loading: false
      });
    }).catch(this.handleError);
  };

  ChatOperator.prototype.sendLogout = function sendLogout() {
    var messageData = {
      action: 'ChatServer',
      method: 'logout',
      data: null,
      type: 'rpc',
      tid: this.state.sentMessages.length + 1
    };

    this.setState(function (prevState) {
      return {
        loading: true,
        sentMessages: prevState.sentMessages.concat([messageData])
      };
    });

    fetch('' + this.props.chatURL + send, {
      method: 'POST',
      body: JSON.stringify(messageData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(this.handleError);
  };

  ChatOperator.prototype.handleError = function handleError(err) {
    console.error('errore sconosciuto', err);

    if (this.state.checkMessageHandle) {
      clearInterval(this.state.checkMessageHandle);
    }

    this.setState({
      loading: false,
      error: err
    });

    this.addMessage({
      text: 'Si è verificato un errore. Riprova più tardi!',
      user: 'ERROR'
    });
  };

  ChatOperator.prototype.render = function render() {
    var _this7 = this;

    return React.createElement(
      Wrapper,
      null,
      this.props.children,
      React.createElement(MessageList, {
        messages: this.props.messages,
        loading: this.state.loading
      }),
      React.createElement(TextBox, {
        loading: this.state.loading,
        onKeyPress: function onKeyPress(e) {
          return _this7.handleQuestion(e);
        }
      })
    );
  };

  return ChatOperator;
}(Component);

export { ChatOperator as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/chat-operator.js
// module id = 888
// module chunks = 1